import {loginReq} from '../Api/index';
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import decClims from "../../../utils/decClaims";
import Cookies from "js-cookie";
import {baseApiUrl} from '../../../env';
import axios from "axios";
// import { setLanguageLock } from '../../../i18n';







const handleAuthSuccess = (data, dispatch, navigate, handleSuccess) => {
  if (!data?.data?.data?.needCaptcha) {
    const claims = data?.data?.data?.claims || [];
    const collectionId = data?.data?.data?.collectionId;
    const secureClaims = data?.data?.data?.secureClaims;
    const refreshToken =  data?.data?.data?.refreshToken;
  //  setLanguageLock(true);
    // console.log(secureClaims)

    const resultClaime = decClims(secureClaims);
    Cookies.set("collectionId", collectionId, { expires: 7 });
     localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("claims", JSON.stringify(resultClaime));

    const userInfo = {
      // token: data?.data?.data?.token,
      userId: data?.data?.data?.id,
      personId: data?.data?.data?.personId,
      userRole: data?.data?.data?.userRoles,
      userLogin:{
        fristName: data?.data?.data?.firstName,
        lastName: data?.data?.data?.lastName,
      },
      userImageUr: data?.data?.data?.userImageUrl,
    };

    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    navigate("/dashboard/overview", { replace: true });

    const actionDetails = {};
    if (claims.length > 0) {
      claims.forEach((element) => {
        actionDetails[element.controllerName] = element.actionDetails;
      });
      dispatch(setActionsControleR(actionDetails));
    }

    handleSuccess?.("ورود موفق");
  } else {
    dispatch(setCaptchR(true));
  }
};



const useLoginReq = (handleSuccess, handleFailedLoginRequest) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useMutation(
    (data) => loginReq(data),
    {
      onSuccess: (data) => {
        console.log(data)
        if (data) {
        handleAuthSuccess(data, dispatch, navigate, handleSuccess);
          
        }
      },
      onError: (error) => {
        console.log(error,'eeeeeeeeeeeeeeee');
        const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
        if (errorList) {
          errorList.forEach((errorListItem) => {
            const element = errorListItem.resourceKeys;
            element.forEach((errorText) => handleFailedLoginRequest?.(errorText));

            // console.log(errorList,'errorListerrorListerrorListerrorList')
          });
        } else {
          handleFailedLoginRequest?.("خطایی رخ داده است");
        }
      },
    }
  );
};

const getLoginPage = async (id) => {
  const response = await axios.get(`${baseApiUrl}/api/v1/LoginPage/GetLoginPage`, {
    params: { id },
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
    withCredentials: true,
  });
  return response.data?.data;
};

export {
    useLoginReq,
    getLoginPage
}